export default __webpack_public_path__ + "static/media/icon-video-call.5a687982.svg";